import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Agriculturalmachinery } from '../../components/mechanization/Agriculturalmachinery';

const AgriculturalmachineryPage: React.FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Сельхоз техника</title>
            </Helmet>
            <Agriculturalmachinery
                latitude={41.20438}
                longitude={74.766098}
            />
        </>
    );
};

export default AgriculturalmachineryPage;
